"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _SailScheduleOne = _interopRequireDefault(require("@/components/SailScheduleOne"));
var _cutTime = require("@/api/cutTime/cutTime");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _utils = require("@/utils");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "cutTime",
  components: {
    sailSchedule: _SailScheduleOne.default,
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      listQuery: {
        currentPage: 1,
        pageSize: 10,
        vesselCode: "",
        vesselName: "",
        vesselNameCn: "",
        voyageNo: "",
        voyageLeg: "",
        startDate: "",
        toDate: "",
        portCode: "",
        dataTime: [],
        dgDeadlineTime: '',
        frCutOffTime: '',
        akCutOffTime: '',
        cutOffTime: '',
        cutVgmDate: ''
      },
      total: 0,
      tableData: [],
      sailScheduleDialogVisible: false,
      hotSettings: {
        dragCheck: true,
        height: 'calc(100vh - 300px)',
        width: 'auto',
        overflow: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: false,
        fixedColumnsLeft: 1
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  mounted: function mounted() {
    var _this = this;
    this.defaultTime();
    this.$nextTick(function () {
      _this.resizeHotTable();
      console.log(_this.tableData, '1111');
    });
    this.getInit();
  },
  watch: {
    '$route': 'getInit'
  },
  methods: {
    getInit: function getInit() {
      if (!(0, _validate.validateNull)(this.$route.query)) {
        this.handleReset();
        this.listQuery.dataTime = [];
        this.listQuery = JSON.parse(this.$route.query.cutTimeVessel);
      } else {
        this.defaultTime();
      }
    },
    defaultTime: function defaultTime() {
      var now = new Date();
      var startDate = new Date();
      startDate.setDate(now.getDate() - 7);
      var endDate = new Date();
      endDate.setDate(now.getDate() + 60);
      var formatDate = function formatDate(date) {
        var year = date.getFullYear();
        var month = (date.getMonth() + 1).toString().padStart(2, '0');
        var day = date.getDate().toString().padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day);
      };
      this.listQuery.startDate = formatDate(startDate);
      this.listQuery.toDate = formatDate(endDate);
      this.listQuery.dataTime = [formatDate(startDate), formatDate(endDate)];
    },
    validateEtdTimeDay: function validateEtdTimeDay() {
      var diffTime = Math.abs(new Date(this.listQuery.toDate) - new Date(this.listQuery.startDate));
      var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays > 68) {
        this.defaultTime();
        this.$message.error(this.$t('cutTime.etdBetween'));
        return;
      }
    },
    resizeHotTable: function resizeHotTable() {
      this.$refs.hotTable.resizeTo();
    },
    convertListQuery: function convertListQuery() {
      var _this$listQuery = this.listQuery,
        currentPage = _this$listQuery.currentPage,
        pageSize = _this$listQuery.pageSize,
        vesselCode = _this$listQuery.vesselCode,
        voyageNo = _this$listQuery.voyageNo,
        voyageLeg = _this$listQuery.voyageLeg,
        startDate = _this$listQuery.startDate,
        toDate = _this$listQuery.toDate,
        portCode = _this$listQuery.portCode,
        dgDeadlineTime = _this$listQuery.dgDeadlineTime,
        frCutOffTime = _this$listQuery.frCutOffTime,
        akCutOffTime = _this$listQuery.akCutOffTime,
        cutOffTime = _this$listQuery.cutOffTime,
        cutVgmDate = _this$listQuery.cutVgmDate;
      return {
        currentPage: currentPage,
        pageSize: pageSize,
        namedParameters: {
          vesselCode: vesselCode,
          voyageNo: voyageNo,
          voyageLeg: voyageLeg,
          startDate: startDate,
          toDate: toDate,
          portCode: portCode,
          dgDeadlineTime: dgDeadlineTime,
          frCutOffTime: frCutOffTime,
          akCutOffTime: akCutOffTime,
          cutOffTime: cutOffTime,
          cutVgmDate: cutVgmDate
        }
      };
    },
    handleDateRangeChange: function handleDateRangeChange(dates) {
      var _dates = (0, _slicedToArray2.default)(dates, 2),
        startDate = _dates[0],
        endDate = _dates[1];
      this.listQuery.startDate = startDate;
      this.listQuery.toDate = endDate;
      this.validateEtdTimeDay();
    },
    handleOpenVessel: function handleOpenVessel() {
      this.sailScheduleDialogVisible = true;
    },
    selectionChange: function selectionChange(row) {
      this.sailScheduleDialogVisible = false;
      this.listQuery.vesselCode = row.vesselCode;
      this.listQuery.vesselName = row.vesselName;
      this.listQuery.voyageLeg = row.voyageLeg;
      this.listQuery.voyageNo = row.voyageNo;
    },
    handleSearch: function handleSearch() {
      var _this2 = this;
      if (!Array.isArray(this.listQuery.dataTime) || this.listQuery.dataTime.length == 0) {
        this.listQuery.startDate = '';
        this.listQuery.toDate = '';
      }
      if (this.listQuery.vesselCode == '' && this.listQuery.voyageNo == '' && this.listQuery.voyageLeg == '' && this.listQuery.startDate == '' && this.listQuery.toDate == '') {
        this.$message.error(this.$t('cutTime.vesselAndVoyageOrEtdNotNull'));
        return;
      }
      this.$refs['filterForm'].validate(function (valid) {
        if (valid) {
          var data = _this2.convertListQuery();
          _this2.loading = (0, _utils.load)();
          (0, _cutTime.queryCutTime)(data).then(function (res) {
            _this2.total = res.data.totalRecord;
            _this2.tableData = res.data.records;
            if (_this2.tableData.length == 0) {
              _this2.hotSettings.height = 'calc(100px)';
              // this.$refs.hotTable.resizeTo()
            }
          }).catch(function (err) {}).finally(function () {
            _this2.loading.close();
          });
        }
      });
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.handleSearch();
    },
    handleReset: function handleReset() {
      for (var key in this.listQuery) {
        this.listQuery[key] = '';
      }
      this.defaultTime();
      this.listQuery.currentPage = 1;
      this.listQuery.pageSize = 10;
    }
  }
};